import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import ReactDOM from 'react-dom';
import { IconAlertMessage } from '@sfx/icons';
import useModal from '../../../hooks/useModal';

function Banner(props) {
  var description = props.description,
      onClose = props.onClose,
      prefix = props.prefix,
      translate = props.translate,
      modalContent = props.modalContent;

  var handlerModalOk = function handlerModalOk() {
    close();
    onClose && onClose();
  };

  var handlerModalClose = function handlerModalClose() {
    onClose && onClose();
  };

  var _useModal = useModal(handlerModalOk, undefined, handlerModalClose),
      _useModal2 = _slicedToArray(_useModal, 7),
      open = _useModal2[1],
      close = _useModal2[2],
      renderModal = _useModal2[6];

  var onOpen = function onOpen() {
    open({
      title: translate('SFxTipsDetail'),
      okText: '',
      hideCancel: true,
      hideOk: true
    });
  };

  var componentClass = "".concat(prefix, "-user-request-banner");
  return /*#__PURE__*/React.createElement("div", {
    className: componentClass
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-icon")
  }, /*#__PURE__*/React.createElement(IconAlertMessage, {
    size: 16
  })), description, "\xA0", /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-link"),
    onClick: onOpen
  }, translate('SFxTipsDetail')), renderModal({
    children: modalContent
  }));
}

var openBanner = function openBanner(properties) {
  var _ref = properties || {},
      getContainer = _ref.getContainer,
      props = _objectWithoutProperties(_ref, ["getContainer"]);

  var div = document.createElement('div');
  var root = getContainer();
  root.appendChild(div);

  var onClose = function onClose() {
    if (root.childNodes.length) {
      ReactDOM.unmountComponentAtNode(div);
      root.removeChild(div);
    }
  };

  ReactDOM.render( /*#__PURE__*/React.createElement(Banner, _extends({}, props, {
    onClose: onClose
  })), div);
  return {
    remove: onClose
  };
};

var Tips = {
  show: openBanner
};
export default Tips;